import React from "react";
import { Tabs } from "antd";
import { AppstoreOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import ServiceWarrantyCatalogList from "./ServiceWarrantyCatalogList";
import ClaimedWarrantiesList from "./ClaimedWarrantiesList";

const WarrantyServiceApp = () => {
    const tabItems = [
        {
            key: 'catalog',
            label: (
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <AppstoreOutlined />
                    Service Warranty
                </span>
            ),
            children: <ServiceWarrantyCatalogList />,
        },
        {
            key: 'claimed',
            label: (
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <SafetyCertificateOutlined />
                    Claimed Warranties & Claims
                </span>
            ),
            children: <ClaimedWarrantiesList />,
        },
    ];

    return (
        <div className="flex mainWrapper w-full">
            <div className="sidenav-wrapper">
                <SideNavbar />
            </div>
            <div className="right-container">
                <div className="header-container">
                    <Header />
                </div>
                <div className="body-container">
                    <div style={{ padding: '16px 20px 0' }}>
                        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 600, color: '#1f2937' }}>
                            Warranty Service App
                        </h2>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 13 }}>
                            Manage service warranty offerings and view all claimed warranties
                        </p>
                    </div>
                    <Tabs defaultActiveKey="catalog" size="large" style={{ margin: '0 20px' }} items={tabItems} />
                </div>
            </div>
        </div>
    );
};

export default WarrantyServiceApp;
